import { Link } from 'react-router-dom';
import { comicImages } from '@/mocks/comics';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  rating: number;
  status: string;
  updateChapter: string;
}

export default function ComicCard({
  id,
  title,
  author,
  rating,
  status,
  updateChapter,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={comicImages[id]}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm px-1.5 py-0.5 rounded-full">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-xs text-accent-500"></i>
          </div>
          <span className="text-xs font-semibold text-foreground-900">{rating}</span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mb-1">{author}</p>
      <p className="text-xs text-primary-500 font-medium">{updateChapter}</p>
    </Link>
  );
}